// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';

/**
 * Return the nextState corresponding to the BASKET_SET_ELIGIBLE_BONUSES action
 *
 * @static
 * @param  {Object} state  The actual state
 * @param  {Object} action The action to reduce
 * @return {Object}        Return the new state.
 */
const basketSetEligibleBonuses = (state, action) => {
  const { status, selectedBonusId } = state;
  const { eligibleBonuses } = action.payload;
  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    const shouldClearSelectedBonusId =
      eligibleBonuses.filter((x) => x.promotionId === selectedBonusId && !x.deleted).length === 0;
    return {
      ...state,
      eligibleBonuses,
      selectedBonusId: shouldClearSelectedBonusId ? undefined : selectedBonusId,
    };
  }
  return state;
};

export default basketSetEligibleBonuses;
